(function () {
    "use strict";

    var DateIndexParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.DateIndexParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.settings = options.settings ? options.settings : {};
            this.monthEnd = this.settings.monthEnd ? true : false;

            this.currentDateIndex = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            if (this.currentDateIndex && this.monthEnd) {
                this.currentDateIndex = InvData.Util.DateIndexHelper.getDateIndexOfLastDayInMonth(this.currentDateIndex);
            }

            this._dateFormat = this.monthEnd ? "MMM yyyy" : "MMM d, yyyy";
        });

    DateIndexParameterControl.getLabel = function (value): string | undefined {
        if (Solovis.isNull(value)) {
            return undefined;
        }
        try {
            const date = InvData.Util.DateIndexHelper.getDateFromDateIndex(value);
            return kendo.toString(date, "MMM d, yyyy");
        } catch (ex) {
            return "(" + parseInt(value.toString()) + ")";
        }
    };

    DateIndexParameterControl.prototype.doInit = function () {
    };

    DateIndexParameterControl.hasNewRender = true;

    DateIndexParameterControl.prototype.doRender = async function () {
        const enabled = (this.options as Solovis.UI.BaseControlOptions).renderMode === 'modern';
        if (enabled) {
            this.doRenderNew();
        } else {
            this.doRenderClassic();
        }
    }

    DateIndexParameterControl.prototype.doRenderClassic = function () {
        var self = this;

        this._backLink = $("<a>").html("<span class='fa fa-chevron-left'></span>").css("margin-right", "15px").appendTo(this.container)
            .addClass("no-selection")
            .click(function () {
                if (self.currentDateIndex) {
                    var newDateIndex;
                    if (self.monthEnd) {
                        newDateIndex = InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousMonth(self.currentDateIndex);
                    }
                    else {
                        newDateIndex = self.currentDateIndex - 1;
                    }
                    self._setCurrentDateIndex(newDateIndex);
                    self.notifyParameterValueChanged();
                }
            });

        this.selectedDateLabel = $("<span>").appendTo(this.container)

        this.selectDateLink = $("<a>").html("<span class='fa fa-pencil'></span>").css("margin-left", "5px").appendTo(this.container);

        this.selectDateLink.click(function () {
            self._toggleSelectorDialog(function (dateIndex) {
                self._setCurrentDateIndex(dateIndex);
                self.notifyParameterValueChanged();
            });
        });

        this._nextLink = $("<a>").html("<span class='fa fa-chevron-right'></span>").css("margin-left", "15px").appendTo(this.container)
            .addClass("no-selection")
            .click(function () {
                if (self.currentDateIndex) {
                    var newDateIndex;
                    if (self.monthEnd) {
                        newDateIndex = InvData.Util.DateIndexHelper.getDateIndexOfLastDayInMonth(self.currentDateIndex + 1);
                    }
                    else {
                        newDateIndex = self.currentDateIndex + 1;
                    }
                    self._setCurrentDateIndex(newDateIndex);
                    self.notifyParameterValueChanged();
                }
            });

        if (this.currentDateIndex) {
            this._setCurrentDateIndex(this.currentDateIndex);
        }
    };

    DateIndexParameterControl.prototype.doRenderNew = function () {
        const self = this;
        const target = self.container[0];

        const currentDate = InvData.Util.DateIndexHelper.getDateFromDateIndex(self.currentDateIndex)
        // NOTE: current new impl does not account for month-end mode (this.monthEnd = true)
        if (target) { 
            Solovis.UX.Utils.placeComponent(
                'DatePicker',
                target,
                {
                    dateFormat: self._dateFormat,
                    defaultValue: currentDate,
                    // NOTE: the bounds below come from InvData.Util.DateIndexHelper::getDateFromDateIndexUsingSlowMethod
                    // should prevent an invalid date index.
                    minDate: new Date(1900, 0, 1),
                    maxDate: new Date(2149, 11, 31),
                    onChange: (date) => {
                        try {
                            // NOTE: _setCurrentDateIndex is responsible for updating the stored value, and there is some 
                            // month selection logic; however, current impl does not support month-end mode and the "error"
                            // handling there is visual.
                            const dateIndex = InvData.Util.DateIndexHelper.getDateIndexFromDate(date)
                            self.currentDateIndex = dateIndex;
                            self.notifyParameterValueChanged();
                        } catch (error) {
                            // TODO: actual error handling for these controls.
                        }
                    }
                }
            )
        }
    }

    DateIndexParameterControl.prototype._setCurrentDateIndex = async function (newDateIndex) {
        if (newDateIndex && this.monthEnd) {
            newDateIndex = InvData.Util.DateIndexHelper.getDateIndexOfLastDayInMonth(newDateIndex);
        }
        
        this.currentDateIndex = newDateIndex;
        if (Solovis.isNotNull(this.currentDateIndex)) {
            let dateStr = null;
            try {
                let date = InvData.Util.DateIndexHelper.getDateFromDateIndex(this.currentDateIndex);
                dateStr = kendo.toString(date, this._dateFormat);
            }
            catch (ex) {
                // Unsupported date index.
                dateStr = "(" + parseInt(this.currentDateIndex.toString()) + ")";
            }

            this.selectedDateLabel.text(dateStr);
        }
        else {
            this.selectedDateLabel.text("");
        } 
    };
   

    DateIndexParameterControl.prototype.setParameterValue = function (newValue, more) {
        Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
            this, DateIndexParameterControl, this._setCurrentDateIndex, newValue, more);
    };

    DateIndexParameterControl.prototype.getParameterValue = function () {
        return this.currentDateIndex;
    };

    DateIndexParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };


    DateIndexParameterControl.prototype._toggleSelectorDialog = function (selectionCallback) {
        var self = this;

        if (this._selectionDialog) {
            // We already have the selection dialog open, so close it.
            this._selectionDialog.close();
            this._selectionDialog = null;
            return;
        }

        var selectorControlHostDiv = $("<div>");

        var dateInput = new Solovis.UI.InputControl({
            container: selectorControlHostDiv,
            type: "date",
            monthEnd: this.monthEnd,
            value: this.currentDateIndex ? InvData.Util.DateIndexHelper.getDateFromDateIndex(this.currentDateIndex) : null,
            validationModel: new Solovis.UI.InputControls.ValidationModel(),
            escapeKey: function () {
                self._selectionDialog.close();
            },
            change: function () {
                var newDate = this.value();

                var newDateIndex = newDate ? InvData.DayId.forDate(newDate) : null;

                selectionCallback(newDateIndex);

                self._selectionDialog.close();
            }
        });

        var buttonSpan = $("<span>").css("display", "inline-block").css("vertical-align", "top").css("padding-top", "2px").css("padding-left", "4px").appendTo(selectorControlHostDiv);

        $("<button>").text("Clear").appendTo(buttonSpan)
            .click(function () {
                selectionCallback(null);
                self._selectionDialog.close();
            });

        $("<button>").text("Cancel").appendTo(buttonSpan)
            .click(function () {
                self._selectionDialog.close();
            });

        // Determine dialog position.        
        var linkOffset = $(this.selectedDateLabel).offset();
        var linkHeight = $(this.selectDateLink).outerHeight();
        var dialogPosition = {
            left: linkOffset.left,
            top: linkOffset.top + linkHeight + 5
        };

        var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

        this._selectionDialog = new Solovis.UI.Dialog({
            container: selectorControlHostDiv,
            ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

            title: false,
            autoOpen: true,
            destroyOnClose: true,
            actions: ["Close"],
            noAnimation: true,
            position: adjustedPosition,

            activate: function () {
                (dateInput as any)._datePicker.open();
                dateInput._input.focus();
            },

            deactivate: function () {
                self._selectionDialog = null;
            }
        });
    };


})();